var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListItem", {
    attrs: { "is-recipient": "", info: "" },
    scopedSlots: _vm._u([
      {
        key: "text",
        fn: function() {
          return [
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.customer.nameWithSalutation))
            ]),
            _vm._v(" "),
            _vm.customer.role
              ? _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.customer.role))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.customer.companyName))
            ]),
            _vm._v(" "),
            _vm.customer.websiteLink
              ? _c("div", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.customer.websiteLink,
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.customer.website))]
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }